import { BaseDetector, DetectorType } from '@src/slide/application/service/snap-line-service/detector/base';
import { LineType } from '@src/slide/application/service/snap-line-service/interface/line.interface';
import { RefSourceType } from '@src/slide/application/service/snap-line-service/interface/ref.interface';
import type { ISnapGridLine, IActiveSnapGridLine } from '@src/slide/application/service/snap-line-service/interface/line.interface';

/**
 * 边缘、基线探测器
 */
export class EdgeAndBaseLineDetector extends BaseDetector {
    public type = DetectorType.STATIC;

    /**
     * 为了降低时间复杂度，边缘和基线放在同一次遍历中判定
     */
    protected collectRefGrids(): ISnapGridLine[] {
        return this.staticRefer.refGrids;
    }

    protected processActiveSnapLines(activeSnapLines: IActiveSnapGridLine[]): IActiveSnapGridLine[] {
        // 如果边距吸附线和基线吸附线位置一样 且 同一方向
        // 为了简化吸附线显示过滤掉基线吸附线
        return this.filterBaseLineIfEdgeLineActive(activeSnapLines);
    }

    private filterBaseLineIfEdgeLineActive(activeSnapLines: IActiveSnapGridLine[]) {
        return activeSnapLines.filter((snapLine) => {
            const isBaseLine = snapLine.type === LineType.BASE_LINE;
            const isSlideBaseLine = snapLine.source === RefSourceType.SLIDE;
            if (!isSlideBaseLine && isBaseLine) {
                const isConflict = activeSnapLines.some((otherSnapLine) => {
                    const isEdgeLine = otherSnapLine.type === LineType.EDGE;
                    return isEdgeLine && otherSnapLine.orient === snapLine.orient;
                });

                return !isConflict;
            }

            return true;
        });
    }
}
